import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
export class VehicleModelInsuranceDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
        this.limit = initializer.limit;
        this.indemnification = initializer.indemnification;
        this.compensation = initializer.compensation;
        this.age = initializer.age;
        this.experience = initializer.experience;
        this.content = initializer.content;
    }
}
